import { toast } from "react-toastify";
import rootReducer from "../../../../store";
import {
  RenderPage,
  editModal,
  openModal,
  resetFormState,
  setTableLoading,
  updateRendererFormState,
} from "../../../../slices/common/reducer";
import { showToast } from "../../../../common/Toaster/Toaster";
import {
  setOrgId,
  setPspMappingData,
  setUserIdData,
  setUsersData,
  setUsersFieldJson,
  setUsersRoleDropdown,
} from "../../../../slices/team/users/usersSlice";
// import { getRoleList } from "../Roles/RolesService";
import { setRolesData } from "../../../../slices/team/users/usersSlice";
import api from "../../../../Utils/interface";

export const getAllRoles = (params, status, fieldJson) => {
  // const setLoadingTimeout = setTimeout(() => {
  //   store.dispatch(setTableLoading(true));
  // }, 300);

  api
    .get(`/v1/entity/readAll/ROL/${status}`, {
      params: params,
    })
    .then((response) => {
      rootReducer.dispatch(setRolesData(response.data));

      // clearTimeout(setLoadingTimeout);
      // rootReducer.dispatch(setTableLoading(false));

      if (fieldJson) {
        const customValues = Array.isArray(response?.data)
          ? response.data.map((item) => ({
            label: item.name,
            value: item.id,
          }))
          : [];
        rootReducer.dispatch(setUsersRoleDropdown(customValues));

        const updatedUsersFieldJson = {
          ...fieldJson,
          "1691129872952-customSelect": {
            ...fieldJson["1691129872952-customSelect"],
            "data-customvalue": customValues,
          },
        };
        rootReducer.dispatch(setUsersFieldJson(updatedUsersFieldJson));
      }
    })
    .catch((error) => {
      console.log(error);

      // clearTimeout(setLoadingTimeout);
      // rootReducer.dispatch(setTableLoading(false));
    });
};

export let createUser = async (entity, entityType, organizationid) => {
  const updatedEntity = {
    ...entity,
    entitytype: entityType,
    organizationid: organizationid,
  };
  let fd = new FormData();
  fd.append("entity", JSON.stringify(updatedEntity));
  fd.append("entitytype", entityType);

  await api
    .post(`/entity/create`, fd, {})
    .then((response) => {
      rootReducer.dispatch(RenderPage());
      rootReducer.dispatch(resetFormState());
      rootReducer.dispatch(openModal(false));
      showToast("User added successfully", "success");
    })
    .catch((error) => {
      // const roleName = entity.name;
      showToast(error?.response?.data?.error_message, "error");
    });
};

export let updateUser = async (entity, entityid, entityType, navigator) => {
  const updatedEntity = {
    ...entity,
    entityid: entityid,
    entitytype: entityType,
  };

  let fd = new FormData();
  fd.append("entity", JSON.stringify(updatedEntity));
  fd.append("entityid", entityid);
  fd.append("entitytype", entityType);

  await api
    .post(`/entity/update`, fd, {})
    .then((response) => {
      rootReducer.dispatch(RenderPage());
      rootReducer.dispatch(resetFormState());
      rootReducer.dispatch(editModal(false));
      rootReducer.dispatch(openModal(false));
      navigator("/team/user");
      showToast("User Updated Successfully!", "success");
    })
    .catch((error) => {
      showToast(error?.response?.data?.error_message, "error");
    });
};

export const getRoles = (entityType, organizationId, fieldJson) => {
  const setLoadingTimeout = setTimeout(() => {
    rootReducer.dispatch(setTableLoading(true));
  }, 300);
  api
    .get(`/agsp/getDistinctRoleByOrganizationId`, {
      params: {
        entityType: entityType,
        organizationId: organizationId,
      },
    })
    .then((res) => {
      rootReducer.dispatch(setRolesData(res.data));
      clearTimeout(setLoadingTimeout);

      if (fieldJson) {
        const customValues = Array.isArray(res?.data)
          ? res.data.map((item) => ({
            label: item.name,
            value: item.entityid,
          }))
          : [];

        rootReducer.dispatch(setUsersRoleDropdown(customValues));

        const updatedUsersFieldJson = {
          ...fieldJson,
          "1692363731639-customSelect": {
            ...fieldJson["1692363731639-customSelect"],
            "data-customvalue": customValues,
          },
        };
        rootReducer.dispatch(setUsersFieldJson(updatedUsersFieldJson));
      }
    })
    .catch((err) => {
      console.log(err);
      clearTimeout(setLoadingTimeout);
      rootReducer.dispatch(setTableLoading(false));
    });
};

export const getUserData = (entity_id, entity_type) => {
  let fd = new FormData();

  fd.append("entityid", entity_id);
  fd.append("entitytype", entity_type);
  api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      if (res) {
        rootReducer.dispatch(setUserIdData(res.data));
        rootReducer.dispatch(updateRendererFormState(res.data));
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUserOrgListing = (
  entityId,
  organizationType,
  ownerId,
  functionName
) => {
  let fd = new FormData();

  fd.append("entityId", entityId);
  fd.append("organizationType", organizationType);
  fd.append("ownerId", ownerId);
  api
    .post(`/agsp/getUserToOrgMappingData`, fd)
    .then((res) => {
      rootReducer.dispatch(functionName(res.data));
      // rootReducer.dispatch(setEntityId(res.data[0].entityid))
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUserOrgMapping = (
  entity_id,
  entity_type,
  user_id,
  action_flag,
  functionName
) => {
  let fd = new FormData();
  fd.append("entity_id", entity_id);
  fd.append("entity_type", entity_type);
  fd.append("user_id", user_id);
  fd.append("action_flag", action_flag);

  api
    .post(`/agsp/getUsrOrgMapping`, fd, {})
    .then((res) => {
      rootReducer.dispatch(functionName(res.data));
      rootReducer.dispatch(RenderPage());
    })
    .catch((err) => {
      console.log(err);
    });
};

export const userProductMappingAction = (
  entity_id,
  product_ids,
  action_flag,
  functionName
) => {
  const requestBody = {
    user_id: entity_id,
    product_id: Array.isArray(product_ids) ? product_ids : [product_ids],
    action_flag: action_flag,
  };

  api
    .post(`/product/userProductMapping`, requestBody, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      rootReducer.dispatch(RenderPage());
      if (functionName) {
        getUserProductList(entity_id, functionName);
      }
    })
    .catch((err) => {
      console.log(err);
    });

};
